module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('button', {
    staticClass: "button button--full-width button--primary submit-form-button",
    class: {
      'button--disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.click($event)
      }
    }
  }, [(!_vm.disabled) ? [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.disabled) ? [_c('div', {
    staticClass: "submit-form-button__loading-spinner"
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53d7715e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/submitBookingButton.vue
// module id = 601
// module chunks = 0